import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { formatDate2string } from "../util/index.js";
import { fetchWithRetry } from "../util/fetchWithRetry";
import "../styles/global.css";
import "../styles/operational.css";
import OperationalDashboardGraph from "../components/operationalDashboardGraph.js";
import OperationalDashboardTable from "../components/operationalDashBoardTable.js";
import OperationalDashboardHistory from "../components/operationalDashboardHistory.js";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faFileAlt,
  faRedoAlt,
  faCalendarAlt
} from "@fortawesome/free-solid-svg-icons";

function OperationalDashboard({ appState }) {
  const today = new Date();
  const time = moment(today).format("HH:mm");
  const [operationalData, setOperationalData] = useState([]);
  const [realodDashboard, setRealodDashboard] = useState({action: false});
  const [state, setState] = useState({
    status: "idle",
    message: "",
    view: "table",
  });
  const [failed, setFailed] = useState([]);

  const getOperationalData = async (location) => {
    const { siteId, locationId, siteName, token } = location;
    const getMethod = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        siteid: siteId,
        authorization: token,
        locationid: locationId,
      },
    };

    const url = `/api/site/${siteId}/locations/${locationId}/summary?appointmentDate=${formatDate2string(
      today
    )}`;
    const response = await fetchWithRetry(
      `${process.env.REACT_APP_API_URL}${url}`,
      getMethod,
      { context: `Summary ${siteName} (${siteId}-${locationId})` }
    );
    if (response.ok) {
      const data = {
        data: await response.json(),
        siteId: siteId,
        locationId: locationId,
        siteName: siteName,
      };
      return Promise.resolve(data);
    } else {
      return Promise.resolve({
        error:
          "Failed to retrieve data from site : " +
          siteName +
          " " +
          siteId +
          " at location: " +
          locationId,
        siteId: siteId,
        locationId: locationId,
        siteName: siteName,
      });
    }
  };

  const getData = async () => {
    setState((prevState) => ({
      ...prevState,
      status: "loading",
    }));
    try {
      const dataRequests = appState.directorsAuth.locationsAuth.map((loc) =>
        getOperationalData(loc)
      );
      const data = await Promise.all(dataRequests);
      const goodData = data.filter((item) => {
        return "data" in item;
      });
      const badData = data.filter((item) => {
        return "error" in item;
      });
      setOperationalData(goodData);
      setFailed(badData);
      setState((prevState) => ({
        ...prevState,
        status: "ready",
      }));
      setRealodDashboard((realodDashboard) => ({
        ...realodDashboard,
        action:false
      }));
    } catch (e) {
      console.log(e);
      setState((prevState) => ({
        ...prevState,
        status: "error",
        message: e.message,
      }));
      setOperationalData([]);
    }
  };


  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if(realodDashboard.action) getData();
  }, [realodDashboard.action]);

  const handleSwitchButton = (e) => {
    const { name } = e.currentTarget;

    if (name === "button-table") {
      setState((state) => ({
        ...state,
        view: "table",
      }));
    }
    if (name === "button-graph") {
      setState((state) => ({
        ...state,
        view: "graph",
      }));
    }
    if (name === "button-history") {
      setState((state) => ({
        ...state,
        view: "history",
      }));
    }
  }

  return (
    <div data-cy="operational-dashboard">
      <div className="container">
        <div className="mt-5 lb-title-daily d-flex justify-content-center">
        <h4>Operational Dashboard</h4>
        </div>
        <div className="mt-3 lb-title-daily d-flex justify-content-end">
          <h5>
            {formatDate2string(today)} {time}
          </h5>
        </div>
        
           <div className="d-flex">
             <div className="col-6 d-flex">
             <div className="lb-nav lb-nav-tabs">
                 <div className="lb-nav-item">
                <button
                  name="button-table"
                  className={state.view === "table" ? "lb-nav-link active shadow-sm" : "lb-nav-link shadow"}
                  data-cy="button-table"
                  onClick={(e) => handleSwitchButton(e)}
                >
                  <FontAwesomeIcon className="mt-1" icon={faFileAlt} style={{ fontSize: 25 }} />
                </button>
              </div>


              <div className="lb-nav-item">
                <button name="button-graph"
                  className={state.view === "graph" ? "lb-nav-link active shadow-sm" : "lb-nav-link shadow"}
                  onClick={(e) => handleSwitchButton(e)}
                  data-cy="button-graph"
                >
                  <FontAwesomeIcon className="mt-1" icon={faChartLine} style={{ fontSize: 25 }} />
                </button>
              </div>

              <div className="lb-nav-item">
                <button name="button-history"
                  className={state.view === "history" ? "lb-nav-link active shadow-sm" : "lb-nav-link shadow"}
                  onClick={(e) => handleSwitchButton(e)}
                  data-cy="button-history"
                >
                  <FontAwesomeIcon className="mt-1" icon={faCalendarAlt} style={{ fontSize: 25 }} />
                </button>
              </div>

                 </div>
             </div>
             <div className="justify-content-end d-flex col-6">

                <button name="button-graph"
                  className={"border lb-nav-link active text-white rounded-circle pt-1 p-3 pb-1 m-2 btn-sm"}
                  onClick={(e) => { setRealodDashboard((realodDashboard) => ({...realodDashboard,action:true})) }}
                  data-cy="btn-reload-dashbaoard"
                  style={{ backgroundColor: "#c2608e", borderColor: "#c2608e #c2608e #fff", color: "white" }}>
                    
                  {state.status === "loading" ? 
                  <FontAwesomeIcon spin icon={faRedoAlt} style={{ fontSize: 20 }} />
                  :
                  <FontAwesomeIcon icon={faRedoAlt} style={{ fontSize: 20 }} />
                  }
                </button>
             </div>
         </div>

        <div className="row mt-4">
        {state.status === "loading" && (
            <div className="loading" data-cy="loading-report-message">
              <div className="lb-spinner" />
            </div>
          )}

          {state.status === "error" && (
            <div className="mt-1 mx-auto mb-3 lb-form-submited-error">
              <span data-cy="error-message">{state.message}</span>
            </div>
          )}

          {state.view === "table" &&
            state.status === "ready" && (
              <OperationalDashboardTable
                operationalData={operationalData}
                state={state}
                realodDashboard={realodDashboard}
              />
            )}

          {state.view === "graph" && (
            <OperationalDashboardGraph
              operationalData={operationalData}
              failed={failed}
            />
          )}

          {state.view === "history" && (
            <OperationalDashboardHistory
              locationsAuth={appState.directorsAuth.locationsAuth}
            />
          )}

        </div>
      </div>

    </div>
  );
}

OperationalDashboard.propTypes = {
  appState: PropTypes.object.isRequired,
};
export default OperationalDashboard;
